import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || ''}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};

// Scopes for calling our own API - uses the client ID as the audience
export const apiRequest = {
  scopes: [`api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`],
};

export const dataverseRequest = {
  scopes: [`${import.meta.env.VITE_DATAVERSE_URL || ''}/.default`],
};

// Scopes for the fleet feedback widget (contract v1, 2026-10-21:
// ptc-docs/coordination/plans/2026-10-21-fleet-feedback-widget-contract.md §3). A DIFFERENT
// audience from our own API above -- this calls ptc-core's CRM API, which owns the shared
// feedback endpoint for every app in the fleet.
export const crmFeedbackRequest = {
  scopes: ['api://d80aa38e-6b76-4cf9-96c8-985e718a3a57/access_as_user'],
};

// Same CRM API audience as crmFeedbackRequest above -- the CRM registers ONE generic
// access_as_user scope for every signed-in-staff endpoint, not a scope per endpoint (confirmed:
// ViewsFunction.cs's screen-state/saved-views routes carry no extra role requirement beyond the
// token itself, same as FeedbackFunction.cs). Named generically because this is no longer
// feedback-only -- filter contract v3 §16 (SavedView / StaffScreenState) uses it too, 2026-11-02.
export const crmApiRequest = {
  scopes: ['api://d80aa38e-6b76-4cf9-96c8-985e718a3a57/access_as_user'],
};
